import { gql } from '@apollo/client'

export const COUNT_NOTIFICATIONS = gql`
  query Query {
    count: getCountNotificationsByUser
  }
`

export const USER_NOTIFICATIONS = gql`
  query GetAllNotificationsByUser($limit: Int, $offset: Int) {
    all: getAllNotificationsByUser(limit: $limit, offset: $offset) {
      id
      message
      link
      createdAt
      dayDif
      timeDiff
      notification_type
    }
  }
`

export const UPDATE_VIEWED_NOTIFICATION = gql`
  mutation UpdateViewedNotificationsById($id: Int!) {
    updateViewedNotificationsById(id: $id)
  }
`

export const NOTIFICATION_ADDED = gql`
  subscription NotificationAdd {
    notificationAdd {
      id
      id_user
      type_user
      message
      link
      notification_type
      id_ref
      viewed
      viewed_date
      createdAt
      updatedAt
    }
  }
`

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead($query: String) {
    markAllNotificationsAsRead(query: $query)
  }
`
